// extracted by mini-css-extract-plugin
export var createdDate = "_l4-1";
export var divider = "_l4-2";
export var headerDivider = "_l4-3";
export var messagesCard = "_l4-0";
export var messagesContainer = "_l4-7";
export var messagesContainerWrapper = "_l4-4";
export var pointerCapturingButtonBoxes = "_l4-a";
export var showLeftPanelButton = "_l4-9";
export var showMoreButton = "_l4-c";
export var showMoreButtonContainer = "_l4-b";
export var summaryTitle = "_l4-6";
export var systemMessageCardWrapper = "_l4-d";
export var topButtons = "_l4-8";
export var withPadding = "_l4-5";